module.exports = __webpack_public_path__ + "img/detail-back3.e8da3925.svg";